import {
    SET_NODES, SET_DEVICE_TYPES, SET_DEVICE_STATUSES, SET_NODE_STATUSES, SET_PROXIES, SET_DEVICE_PROXY_STATUSES,
    SET_DEVICE_HEALTH_STATUSES, SET_PROXY_GROUPS, SET_NODE_IPS, SET_DEVICE_PROXY_MODES,
} from "./consts";

// Справочники для выпадающих списков. ПРАВИЛО: страницы берут их отсюда
// через useSelector, а НЕ запрашивают с сервера сами (загрузка — в AppInit).
const initialState = {
    nodes: {},           // {id: name}
    nodeIps: {},         // {id: wan_ip} — публичный IP ноды (рядом с nodes, не в его подписи)
    deviceTypes: {},     // {id: code}
    deviceStatuses: {},  // {status: label}
    nodeStatuses: {},    // {status: label}
    // {id: «socks5://1.2.3.4:8000 · EE»}; все не удалённые, выключенные — с пометкой «(выключен)»
    proxies: {},
    deviceProxyStatuses: {}, // devices.proxy_status → label (setup/removing/ok/error)
    deviceProxyModes: {},    // devices.proxy_mode → label (tcp_udp «TCP + UDP» / tcp «Только TCP»)
    deviceHealthStatuses: {}, // devices.health_status → label (repair/ok/error) — итог аудита ноды
    proxyGroups: {},     // {id: «Пачка октябрь (до 31.10.2026)»} — группы прокси
};

export default function option(state = initialState, action) {
    switch (action.type) {
        case SET_NODES:
            return { ...state, nodes: action.payload };
        case SET_DEVICE_TYPES:
            return { ...state, deviceTypes: action.payload };
        case SET_DEVICE_STATUSES:
            return { ...state, deviceStatuses: action.payload };
        case SET_NODE_STATUSES:
            return { ...state, nodeStatuses: action.payload };
        case SET_PROXIES:
            return { ...state, proxies: action.payload };
        case SET_DEVICE_PROXY_STATUSES:
            return { ...state, deviceProxyStatuses: action.payload };
        case SET_DEVICE_HEALTH_STATUSES:
            return { ...state, deviceHealthStatuses: action.payload };
        case SET_PROXY_GROUPS:
            return { ...state, proxyGroups: action.payload };
        case SET_NODE_IPS:
            return { ...state, nodeIps: action.payload };
        case SET_DEVICE_PROXY_MODES:
            return { ...state, deviceProxyModes: action.payload };
        default:
            return state;
    }
}
